import { render, staticRenderFns } from "./AddCommentDialog.vue?vue&type=template&id=29a98bd4"
import script from "./AddCommentDialog.vue?vue&type=script&lang=js"
export * from "./AddCommentDialog.vue?vue&type=script&lang=js"
import style0 from "./AddCommentDialog.vue?vue&type=style&index=0&id=29a98bd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports